import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation createProjectPersonClientMutation($input: CreateProjectPersonInput!) {
		createProjectPerson(input: $input) {
			projectPerson {
				node {
					id
					person {
						id
						userType
						profileId
						permissions
					}
				}
			}
			projects {
				id
				name
				client {
					id
				}
				projectPersons(first: 1000) {
					edges {
						node {
							id
							person {
								id
								userType
								profileId
								permissions
							}
						}
					}
				}
			}
			project {
				id
				name
				client {
					id
				}
				projectPersons(first: 1000) {
					edges {
						node {
							id
							person {
								id
								userType
								profileId
								permissions
							}
						}
					}
				}
			}
		}
	}
`;

function getConfigs(input) {
	const configs = [];

	if (input.projectId) {
		configs.push({
			type: 'RANGE_ADD',
			parentID: input.projectId,
			connectionInfo: [
				{
					key: 'Project_projectPersons',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'projectPerson',
		});
	}

	return configs;
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Project Person Added');
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
